import '@styles/pages/politique-de-confidentialite.scss';

import { initAnchor } from '@molecules/anchor';

initAnchor();
